import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import { Box as PRCBox } from '@primer/react';
import { Link, Button, Heading, Text } from '@primer/react-brand';
import * as React from 'react';
export default {
  HeroLayout,
  PRCBox,
  Link,
  Button,
  Heading,
  Text,
  React
};